import theme from 'src/theme';
import { NoonReportTypeEnum } from 'src/types/ViewModel/AolEnums';
import styled from 'styled-components';

export const RobPageWrapper = styled.div`
    background-color: white;
    overflow-y: auto;
    flex-grow: 1;
`;

export const RobTableWrapper = styled.div`
    display: flex;
    padding: 12px;
    background-color: white;
    flex-direction: column;
    overflow-y: auto;
    width: fit-content;
    max-width: 100%;
    height: 100%;
`;

export const EmptyDataPage = styled.div`
    display: flex;
    background-color: white;
    justify-content: center;
    width: 100%;
    height: calc(100% - 67px);
`;

export const EmptyDataMessage = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 15%;
`;

export const RobCustomTable = styled.div`
    display: flex;
    width: 100%;
    overflow-y: auto;
    flex: 0 3 auto;

    // max-height: 80%;

    > div:nth-child(n + 2) {
        width: 160px;
        border-left: 1px solid ${theme.legacyColors.darkBlue};
    }

    > div:nth-child(3) {
        width: 80px;
    }

    > div:nth-child(n + 4) {
        width: 400px;
    }
`;

interface RobTableColumnProps {
    displayLossColumn?: boolean;
    debunkeringColumn?: boolean;
}

export const RobTableColumn = styled.div<RobTableColumnProps>`
    ${(props) => props.displayLossColumn && `width: 480px !important;`}
    ${(props) => props.debunkeringColumn && `width: 260px !important;`}
    display: flex;
    flex-direction: column;
`;

export const ColumnHeaderWrapper = styled.div`
    height: 98px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    border-bottom: 2px solid ${theme.legacyColors.darkBlue};
    padding: 4px 8px;
    background-color: ${theme.legacyColors.headerBackground};
`;

interface PrimaryHeaderWrapperProps {
    noonReportType?: NoonReportTypeEnum;
}

export const PrimaryHeaderWrapper = styled.div<PrimaryHeaderWrapperProps>`
    ${(props) => props.noonReportType && props.theme.noonReportTypeListMarker(props.noonReportType, true)}
    padding-left: 4px;
`;

export const TotalRobHeader = styled.div`
    background-color: ${theme.legacyColors.headerBackground};
    display: flex;
    flex-direction: row;
    gap: 8px;
    justify-content: center;
    width: 100%;
    padding: 4px;
    border-bottom: 2px solid ${theme.legacyColors.darkBlue};
    align-self: center;
`;

export const ColumnHeaderTitle = styled.div`
    font-size: 0.9rem;
    font-weight: bold;
    text-align: center;
`;

export const ColumnHeaderSubTitle = styled.div`
    font-size: 0.9rem;
    text-align: center;
`;

export const ColumnHeaderDetails = styled.div`
    font-size: 0.8rem;
    font-weight: normal;
    min-height: 1.25rem;
`;

export const ColumnSubHeader = styled.div`
    font-size: 0.8rem;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    gap: 4px;
    min-height: 2.5rem;

    > div:nth-child {
        justify-text: center;
        flex: 1;
    }

    > div:nth-child(3) {
        flex: 1.4;
    }

    > div:nth-child(5) {
        flex: 0.8;
    }
`;

export const ColumnSubHeaderTitle = styled.div`
    flex: 1;
    align-text: center;
    align-self: flex-end;
    text-align: center;
`;

type RobRowProps = {
    indent?: boolean;
    hideBorderBottom?: boolean;
    hasConsumption?: boolean;
};

export const RobRowStyle = styled.div<RobRowProps>`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    ${(props) => !props.hideBorderBottom && `border-bottom: 1px solid ${theme.legacyColors.darkBlue};`}
    min-height: 31px;
    padding: 0px 8px;
    ${(props) => props.indent && `padding-left: 2rem;`}
    gap: 0.8rem;
    white-space: nowrap;
    ${(props) => props.hasConsumption && `background-color: ${theme.colors.verification.item.selected};`}
`;

type RobRowDataProps = {
    flex?: number;
    sumRow?: boolean;
    debunkeringCalculatedRob?: boolean;
    hasChange?: boolean;
};

export const RobRowDataStyle = styled.div<RobRowDataProps>`
    flex: 1;
    min-height: 5px;
    ${(props) => props.flex && `flex: ${props.flex};`}
    ${(props) => props.sumRow && `text-align: end;`}
    ${(props) => props.debunkeringCalculatedRob && `text-align: center;`}
    ${(props) => props.hasChange && `font-weight: bold;`}
    // ${(props) => props.hasChange && `background-color: ${theme.legacyColors.selectedBackground};`}
    label .input-value-wrapper .input-unit {
        width: 30px; !important;
    }
`;

export const CheckboxWrapper = styled.div`
    label .input-value-wrapper .input-unit {
        width: 10px; !important;
        justify-content: center;
    }
    label .input-value-wrapper {
        justify-content: center;
    }
`;

export const TotalRobWrapper = styled.div`
    background-color: white;
    flex: 1;
    padding-top: 6px;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: auto;
    // max-height: 20%;
`;

export const TotalRobBunkerListWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    gap: 20px;
`;

export const BunkerChangeInputGrid = styled.div`
    display: grid;
    grid-template-columns: auto auto;
    grid-gap: 2px 20px;

    > div:nth-child(odd) {
        justify-self: end;
    }

    > div:nth-child(even) {
        justify-self: start;
    }

    > div > label > div.input-value-wrapper {
        > span.input-value > select.input-select {
            width: 300px;
        }
        > span.textarea-input > div > textarea.input {
            width: 300px;
        }
    }
`;

interface BunkerLossTableProps {
    selected?: boolean;
}

export const BunkerLossTableStyle = styled.table<BunkerLossTableProps>`
    margin-top: 4px;
    margin-bottom: 28px;
    width: 100%;
    border-collapse: collapse;
    thead {
        border-bottom: 1px solid ${theme.legacyColors.darkBlue};
    }
    tbody {
        background-color: white;
    }
    td {
        text-align: left;
        padding: 4px 8px;
    }
`;

export const HeaderStyle = styled.h2`
    border-bottom: 1px solid ${theme.legacyColors.darkBlue};
    margin-bottom: 8px;
`;

import { BunkerRefWarningLevel } from './BunkerRobWarningBanner';

interface WarningBannerProps {
    $severity: BunkerRefWarningLevel;
}

export const WarningBanner = styled.div<WarningBannerProps>`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    border-radius: 4px;
    margin: 12px 12px 0 12px;

    /* Orange for 'atLimit', Red for 'exceeded' */
    background-color: ${({ $severity }) => ($severity === 'exceeded' ? theme.colors.background.warning : theme.colors.background.lightYellow)};
    border: 1px solid ${({ $severity }) => ($severity === 'exceeded' ? theme.colors.status.error : theme.colors.status.warning)};
    color: ${({ $severity }) => ($severity === 'exceeded' ? theme.colors.text.primary : theme.colors.text.warningDark)};

    svg {
        color: ${({ $severity }) => ($severity === 'exceeded' ? theme.colors.status.error : theme.colors.status.warning)};
        font-size: 18px;
    }
`;
